<div class="nlp-question-container">
    <div class="question-header">
        <div style="display: flex; position: relative; width: fit-content; height: fit-content;">
            <img src="assets/navbar-component-images/banner.svg" alt="banner.svg" >
            <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg" style="position: absolute; left: 35%; top: 17%;">
        </div>  
        ป้อนประโยคคำถาม
    </div>
    <div class="question-box-container" (keyup.enter)="pressEnter($event,this.question)">
        <div class="question-box">
            <input type="text" placeholder="ข้อความของคุณ..." [(ngModel)]="question">
            <button [disabled]="!question || question.trim() === ''" type="button" class="send-icon" (click)="getNlp(this.question)">
                <img src="assets/nlp-component-images/search-button-icon.png" alt="">
            </button>
        </div>
    </div>
    <div class="nlp-result-container-false" *ngIf="!nlpResult">
        <div class="img-container" *ngIf="isLoading">
            <img src="assets/nlp-component-images/image_loading_false.svg" alt="">
        </div>
    </div>
    <div class="nlp-result-container-true" *ngIf="nlpResult">
        <!-- <div class="nlp-result-title">
            NLP Result (isLoading : <span>True</span>)
        </div> -->
        <div class="original-question">
            <div class="topic">
                Original Question Sentence
            </div>
            <div class="od-question">
                <div class="message-icon" [style]="{'filter': filter}"><img src="assets/nlp-component-images/ChatText.svg" alt="" style="filter: brightness(0);"></div>
                {{this.searchQuestion}}
            </div>
        </div>
        <div class="word-segmentation">
            <div class="topic">
                Word Segmentation
            </div>
            <div class="word-container">
                <div class="word" *ngFor="let word of this.nlpResult.WordSegment">
                    {{word}}
                </div>
            </div>
        </div>
        <div class="pos-tagging" *ngIf="this.nlpResult.POSTag">
            <div class="topic">
                POS Tagging
            </div>
            <div class="pos-container" >
                <div class="noun-part" *ngIf="this.nlpResult.POSTag['NOUN']">
                    <ul>
                        <li>Noun</li>
                    </ul>
                    <div class="box">
                        <div class="word" *ngFor="let word of this.nlpResult.POSTag['NOUN']">
                            {{word}}
                        </div>
                    </div>
                </div>
                <div class="verb-part" *ngIf="this.nlpResult.POSTag['VERB']">
                    <ul>
                        <li>Verb</li>
                    </ul>
                    <div class="box">
                        <div class="word" *ngFor="let word of this.nlpResult.POSTag['VERB']">
                            {{word}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ner-tagging" *ngIf="this.nerResult">
            <div class="topic">
                NER Tagging
            </div>
            <div class="ner-container">
                <div class="ner-part" *ngFor="let topic of this.nerKey; let i = index">
                    <ul>
                        <li>{{topic}}</li>
                    </ul>
                    <div class="box">
                        <div class="word" *ngFor="let word of this.nerValue[i]">
                            {{word}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="synonym" *ngIf="this.synonym">
            <div class="topic">
                Synonyms
            </div>
            <div class="synonym-container">
                <div class="syn-part" *ngFor="let item of this.synonym">
                    <ul>
                        <li>{{item["InputWords"][0]}}</li>
                    </ul>
                    <div class="box">
                        <div class="word" *ngFor="let word of item['Synonym']">
                            {{word}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
